import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedRangePicker from '@portal/components/AdvancedRangePicker/AdvancedRangePicker';
import AdvancedRadio from '@portal/components/AdvancedRadio/AdvancedRadio';
import {
  ExportExtractMethod,
  StatementFileType,
} from '@portal/models/enumerators';
import { translate } from '@portal/services/i18n';
import { Modal } from 'antd';
import moment, { Moment } from 'moment';
import React, { useState } from 'react';

interface ExportExtractModalProps {
  visible: boolean;
  setModalExtract: (value: boolean) => void;
  handleSubmit: (
    method: ExportExtractMethod,
    startAt: string,
    endAt: string,
    order: 'asc' | 'desc',
    fileType: StatementFileType
  ) => void;
  createdAt: string;
}

const ExportExtractModal = ({
  visible,
  setModalExtract,
  handleSubmit,
  createdAt,
}: ExportExtractModalProps) => {
  const [datePicker, setDatePicker] = useState<[Moment, Moment] | null>(null);
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [fileType, setFileType] = useState<StatementFileType>(
    StatementFileType.PDF
  );
  const [startAt, setStartAt] = useState('');
  const [endAt, setEndAt] = useState('');

  const handleChangeDatePiker = (values: Array<Moment | null> | null) => {
    if (values && values[0] && values[1]) {
      const diffInDays = values[1].diff(values[0], 'days');
      if (diffInDays > 90) {
        return;
      }

      setDatePicker([values[0], values[1]]);
      setStartAt(values[0].utc(true).startOf('day').toISOString());
      setEndAt(values[1].utc(true).endOf('day').toISOString());
    }
  };

  return (
    <Modal
      open={visible}
      footer={
        <div className="extract-page__button">
          <AdvancedButton
            text={translate('PAGES.EXTRACT.EXPORT.SUBMIT_EMAIL')}
            onClick={() =>
              handleSubmit(
                ExportExtractMethod.EMAIL,
                startAt,
                endAt,
                order,
                fileType
              )
            }
            disabled={!datePicker || !startAt || !endAt || !order}
          />
        </div>
      }
      closable
      onCancel={() => setModalExtract(false)}
      className="extract-page-modal"
    >
      <div className="extract-page-modal-content">
        <p className="extract-page-modal-content__header__title">
          {translate('PAGES.EXTRACT.EXPORT.TITLE')}
        </p>
        <div className="extract-page-modal-content__field">
          <h4>{translate('PAGES.EXTRACT.EXPORT.DATE_RANGE_TITLE')}</h4>
          <AdvancedRangePicker
            onChange={handleChangeDatePiker}
            value={datePicker}
            allowClear
            disabledDate={(date) => date > moment() || date < moment(createdAt)}
          />
        </div>

        <div className="extract-page-modal-content__field">
          <h4>{translate('PAGES.EXTRACT.EXPORT.RADIO_TITLE')}</h4>
          <AdvancedRadio
            onChange={(newOrder) => {
              if (newOrder === 'asc' || newOrder === 'desc') {
                setOrder(newOrder);
              }
            }}
            value={order}
            name={translate('PAGES.EXTRACT.EXPORT.RADIO')}
            row
            options={[
              {
                name: translate('PAGES.EXTRACT.EXPORT.ASC_OPTION'),
                value: 'asc',
              },
              {
                name: translate('PAGES.EXTRACT.EXPORT.DESC_OPTION'),
                value: 'desc',
              },
            ]}
          />
        </div>

        <div className="extract-page-modal-content__field">
          <h4>{translate('PAGES.EXTRACT.EXPORT.FILE_TYPE_TITLE')}</h4>
          <AdvancedRadio
            onChange={(newFileType) => {
              if (
                Object.values(StatementFileType).includes(
                  newFileType as StatementFileType
                )
              ) {
                setFileType(newFileType as StatementFileType);
              }
            }}
            value={fileType}
            name={translate('PAGES.EXTRACT.EXPORT.FILE_TYPE')}
            row
            options={[
              {
                name: translate('PAGES.EXTRACT.EXPORT.PDF_OPTION'),
                value: StatementFileType.PDF,
              },
              {
                name: translate('PAGES.EXTRACT.EXPORT.CSV_OPTION'),
                value: StatementFileType.CSV,
              },
              {
                name: translate('PAGES.EXTRACT.EXPORT.OFX_OPTION'),
                value: StatementFileType.OFX,
              },
              {
                name: translate('PAGES.EXTRACT.EXPORT.XLSX_OPTION'),
                value: StatementFileType.XLSX,
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExportExtractModal;
